import React from "react";
import { useDispatch, useSelector } from 'react-redux';
/// React router dom
import { Link, useNavigate } from "react-router-dom";
/// images
import logo from "../../../images/logo.jpg";
// import logoText from "../../../images/logo-text.png";
import { navtoggle } from "../../../store/actions/AuthActions";
import { useState } from "react";

const NavHader = () => {

   const dispatch = useDispatch();
   const [isTitleVisible, setIsTitleVisible] = useState(true);
   const sideMenu = useSelector(state => state.sideMenu);
   const handleToogle = () => {
      dispatch(navtoggle());
   };
   const navigate = useNavigate()
   return (
      <>
         <style>{`
            .nav-header, .adminlogo_container {
               background: #f9fcfcff !important;
            }
            [data-theme-version="dark"] .nav-header, [data-theme-version="dark"] .adminlogo_container {
               background: #ffffff !important;
            }
         `}</style>
         <div className="adminlogo_container" style={{ background: '#ffffff' }}>
            <div className="adminlogo" onClick={() => navigate("/")} style={{ cursor: 'pointer' }}>
               <div className="logo-text" style={{ fontWeight: 'bold', fontSize: '22px' }}>

                  <span style={{ color: '#4d7572ff' }}>MedHorizone</span>
               </div>
            </div>
         </div>
      </>
   );
};

export default NavHader;
